// Indonesian Rupiah formatting utilities

export function toNumber(v) {
  if (typeof v === "number") return isFinite(v) ? v : 0;
  if (v === null || v === undefined || v === "") return 0;
  const n = parseInt(String(v).replace(/[^\d-]/g, ""), 10);
  return isNaN(n) ? 0 : n;
}

// Full format for inputs / detailed display: Rp12.000.000
export function formatFull(v) {
  const n = Math.round(toNumber(v));
  return "Rp" + n.toLocaleString("id-ID");
}

// For raw input display without the Rp prefix (thousand separators): 12.000.000
export function formatInput(v) {
  const n = toNumber(v);
  return n ? n.toLocaleString("id-ID") : "";
}

function trimDecimal(x) {
  const r = Math.round(x * 10) / 10;
  const s = Number.isInteger(r) ? String(r) : r.toFixed(1);
  return s.replace(".", ",");
}

// Compact format: Rp12 jt, Rp1,8 jt, Rp850 rb
export function formatCompact(v) {
  const n = toNumber(v);
  const neg = n < 0;
  const a = Math.abs(n);
  let out;
  if (a >= 1e6) out = trimDecimal(a / 1e6) + " jt";
  else if (a >= 1e3) out = trimDecimal(a / 1e3) + " rb";
  else out = String(Math.round(a));
  return (neg ? "-Rp" : "Rp") + out;
}

// Month formatting: 8,2
export function formatMonths(m, decimals = 1) {
  if (!isFinite(m) || isNaN(m) || m < 0) m = 0;
  const factor = Math.pow(10, decimals);
  const r = Math.round(m * factor) / factor;
  const s = Number.isInteger(r) ? String(r) : r.toFixed(decimals);
  return s.replace(".", ",");
}

// Survival runway display — keeps a readable value for very long runways
// instead of an arbitrary cap. Returns { value, unit }.
export function runwayDisplay(m) {
  if (!isFinite(m) || isNaN(m) || m < 0) m = 0;
  if (m <= 24) return { value: formatMonths(m), unit: "bulan" };
  if (m < 120) return { value: "±" + Math.round(m), unit: "bulan" };
  // 10 years or more → show in years for readability
  return { value: "±" + Math.round(m / 12), unit: "tahun" };
}

// Full one-line runway text, e.g. "10 bulan" / "±30 bulan" / "±14 tahun"
export function runwayFull(m) {
  const d = runwayDisplay(m);
  return `${d.value} ${d.unit}`;
}

// Percentage formatting: 42
export function formatPercent(p, decimals = 0) {
  if (!isFinite(p) || isNaN(p) || p < 0) p = 0;
  const factor = Math.pow(10, decimals);
  const r = Math.round(p * factor) / factor;
  const s = Number.isInteger(r) ? String(r) : r.toFixed(decimals);
  return s.replace(".", ",");
}

// Format a full date in Indonesian: 26 Agu 2026
const MONTHS_ID = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
export function formatDateID(dateInput) {
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return "-";
  return `${d.getDate()} ${MONTHS_ID[d.getMonth()]} ${d.getFullYear()}`;
}
